import { ApiClient } from "./client";

// Mount path of the i18n endpoint. Storybook overrides this before any consumer
// module evaluates (see .storybook/configure-i18n.js) because its static build
// serves the bundles under a non-root base path.
let basePath = "/i18n";

// Cached singleton, built lazily by createI18nApi.
let api;

export function setI18nBasePath(path) {
  basePath = path;
  // Drop the cached instance so the next createI18nApi() call builds a client on
  // the new path.
  api = undefined;
}

class I18nApi extends ApiClient {
  constructor() {
    super({ baseURL: basePath });
  }

  async get(key, locale) {
    // Forward the active locale so the endpoint serves that language. The
    // default locale is left off so its response keeps the cacheable
    // locale-free path (the endpoint page-caches only the default locale).
    const query = locale && locale !== "en" ? `?locale=${encodeURIComponent(locale)}` : "";
    return super.get(`/frontend.${key}.json${query}`);
  }
}

export const createI18nApi = () => {
  api ??= new I18nApi();

  return {
    all: async (key, locale) => api.get(key, locale),
  };
};
